import React from 'react';

// Skeleton de carga UNIFICADO para grillas de imágenes. Lo usan todas las
// superficies que listan imágenes (productos, modelos, poses, fondos,
// escenas, imágenes generadas, etc.) para mostrar el mismo placeholder
// mientras cargan — en vez del mix de spinner / texto / nada.
//
// Cada superficie pasa su propio `gridClassName` (columnas + gap) para que
// el skeleton matchee la grilla real, `tileClassName` para el radio de las
// cards, y `tileAspectClassName` para la FORMA del tile: por defecto
// `aspect-square`, pero puede ser `aspect-[4/5]`, `aspect-[9/16]` o una
// altura fija (`h-24`, `h-28`, etc.) según la grilla. `withLabel` agrega una
// barra de texto debajo (grillas que muestran el nombre debajo de la foto).
// `bare` devuelve solo los tiles (sin contenedor grid) para insertarlos
// dentro de una grilla ya existente.
export interface ProductGridSkeletonProps {
  count?: number;
  gridClassName?: string;
  tileClassName?: string;
  tileAspectClassName?: string;
  withLabel?: boolean;
  bare?: boolean;
}

export const ProductGridSkeleton: React.FC<ProductGridSkeletonProps> = ({
  count = 8,
  gridClassName = 'grid grid-cols-2 gap-3',
  tileClassName = 'rounded-xl',
  tileAspectClassName = 'aspect-square',
  withLabel = false,
  bare = false,
}) => {
  const tiles = Array.from({ length: count }).map((_, i) => (
    <div key={i} className="flex flex-col">
      <div
        className={`${tileAspectClassName} ${tileClassName} bg-neutral-100 animate-pulse`}
      />
      {withLabel && (
        <div className="mt-1.5 h-3 w-2/3 rounded bg-neutral-100 animate-pulse" />
      )}
    </div>
  ));

  if (bare) return <>{tiles}</>;
  return (
    <div className={gridClassName} aria-hidden="true">
      {tiles}
    </div>
  );
};

export default ProductGridSkeleton;
